/**
 * Handle sidebar toggler
 */
document.addEventListener('DOMContentLoaded', function () {
  const sidebarToggler = document.querySelector('.platform-sidebar-toggler');
  const sidebarNav = document.querySelector('.platform-sidebar-nav');

  if (sidebarToggler && sidebarNav) {
    const sidebarNavScrollHeight = sidebarNav.scrollHeight;

    sidebarToggler.addEventListener('click', function () {
      sidebarNav.classList.toggle('active');

      if (sidebarNav.classList.contains('active')) {
        sidebarNav.style.maxHeight = sidebarNavScrollHeight + 'px';
      } else {
        sidebarNav.style.maxHeight = 0;
      }
    });
  }
})